// Import JS
import $ from 'jquery';

import AjaxLogin from './modules/ajax_login_script';
import MiniCart from './modules/mini_cart';
import ReadMore from './modules/read-more';
import ReadMoreArchive from './modules/read-more-archive';
import StickyToolbar from './modules/sticky-toolbar';

import 'bootstrap';

// Initialize JS
const ajaxLogin = new AjaxLogin(); // eslint-disable-line no-unused-vars
const readMore = new MiniCart(); // eslint-disable-line no-unused-vars

// Initialize JS specifically for single product pages.
if ( $( '.single-product' ).length ) {
	const readMore = new ReadMore(); // eslint-disable-line no-unused-vars, no-shadow
}

// Initialize JS specifically for archive pages.
if ( $( '.woocommerce.archive' ).length ) {
	const readMoreArchive = new ReadMoreArchive(); // eslint-disable-line no-unused-vars, no-shadow
	if ( $( '.product-loop-divider' ).length ) {
		const stickyToolbar = new StickyToolbar(); // eslint-disable-line no-unused-vars
	}
}

$( document ).ready( function() {
	require( './click-to-scroll' );
	require( './ac-mobile-menu' );
	require( './carousels' );
	require( './select-boxes' );
	require( './videos' );
	require( './subscribe-member' );
	require( './reject-sop' );
	require( './wc-cle' );
	require( './thank-you' );
	require( './wc-filters' );
	require( './skip-link-focus-fix' );

	( function() {
		const notice = document.querySelector( '.customer-notice' );

		if ( ! notice ) {
			console.log( 'Couldn\'t find notice' ); // eslint-disable-line no-console
			return;
		}

		const dismissButton = document.querySelector( '.customer-notice-close' );
		const noticeId = notice.getAttribute( 'data-id' );
		const storedNoticeId = localStorage.getItem( 'sisuCustomerNotice' );

		if ( noticeId !== storedNoticeId ) {
			notice.style.maxHeight = '500px';
		}

		dismissButton.addEventListener( 'click', function() {
			notice.style.maxHeight = '0';

			localStorage.setItem( 'sisuCustomerNotice', noticeId );
		} );
	}() );
} );
